import React from 'react';
import classes from './Settings.module.scss';
import { SettingsMenu } from '../../Settings/SettingsMenu';

export type SettingsViewProps = {
  closeAction?: VoidFunction;
};

export const SettingsView = (props: SettingsViewProps): JSX.Element => {
  return (
    <>
      <div className={classes.SettingsMenuWrapper}>
        {/* Commented this out as it was hardcoded and will probably be re-designed. */}
        {/*<div className={classes.SettingsUserMessage}>*/}
        {/*  <div className={classes.SettingsMessageBox}>*/}
        {/*    <div className={classes.MessageBoxContent}>*/}
        {/*      <div className={classes.MessageTitle}>11 days</div>*/}
        {/*      <div className={classes.MessageDetail}>Remaining in Your Free Trial</div>*/}
        {/*    </div>*/}
        {/*    <div className={classes.Button}>*/}
        {/*      <Button*/}
        {/*        expanded={true}*/}
        {/*        type={'a'}*/}
        {/*        variant={'solid'}*/}
        {/*        color={ButtonColors.secondary}*/}
        {/*        size={'medium'}*/}
        {/*        action={() => alert('Clicked!')}>*/}
        {/*        Start Free Trial*/}
        {/*      </Button>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <SettingsMenu closeAction={props.closeAction} isLeftSideMenu={false} />
      </div>
    </>
  );
};
